<template>
    <div>
        <section class="section has-background-primary has-text-centered">
            <br><br><br>
            <div class="container is-fluid">
                <h1 class="title has-text-white">We only represent you, the seller</h1>
                <p class="subtitle is-6 has-text-white">As your Sellers' Agent, we will help you price your home right, secure buyers through the best agents in your area and ensure that your sale goes smoothly with our free legal assistance</p>
            </div>
            <br><br><br>
        </section>

        <section class="section has-text-centered">
            <div class="container">
                <div class="columns is-desktop is-centered shift-up">
                    <div class="column grey-column is-2">
                        <h3>Valuation</h3>
                        <br>
                        <div class="container">
                            <img alt="" class="benefit-icon" src="../assets/images/sell_with_us/01_valuation.svg">
                            <p>Local Knowledge and Lightstone Tools giving you sale price certainty</p>
                        </div>
                    </div>

                    <div class="column grey-column is-2">
                        <h3>Top Agents</h3>
                        <br>
                        <div class="container">
                            <img alt="" class="benefit-icon" src="../assets/images/sell_with_us/02_more_buyers.svg">
                            <p>We partner with the top selling agents in your area</p>
                        </div>
                    </div>

                    <div class="column grey-column is-2">
                        <h3>Loyalty</h3>
                        <br>
                        <div class="container">
                            <img alt="" class="benefit-icon" src="../assets/images/sell_with_us/03_max_exposure.svg">
                            <p>We are not affiliated with agents - we act in your interests</p>
                        </div>
                    </div>

                    <div class="column grey-column is-2">
                        <h3>Get More Out</h3>
                        <br>
                        <div class="container">
                            <img alt="" class="benefit-icon" src="../assets/images/sell_with_us/05_get_more.svg">
                            <p>Get the most value out of your biggest asset, your home</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section has-text-centered">
            <div class="container">
                <h2 class="title">Simple steps to sell your home</h2>
                <br>
                <div class="simple-steps-container">
                    <div class="simple-steps">
                        <div class="timeline"></div>
                        <div class="simple-step">
                            <div class="circled-number has-background-green">1</div>
                        </div>
                        <div class="simple-step">
                            <div class="circled-number has-background-green">2</div>
                        </div>
                        <div class="simple-step">
                            <div class="circled-number has-background-green">3</div>
                        </div>
                        <div class="simple-step">
                            <div class="circled-number has-background-green">4</div>
                        </div>
                        <div class="simple-step">
                            <div class="circled-number has-background-green">5</div>
                        </div>
                        <div class="simple-step">
                            <img alt="Sold Sign" src="../assets/images/sell_with_us/sold_sign.svg">
                        </div>
                    </div>
                    <div class="simple-steps">
                        <div class="simple-step">
                            <p>Tell us about your home</p>
                        </div>
                        <div class="simple-step">
                            <p>Free Digital & Onsite valuation to help you price right</p>
                        </div>
                        <div class="simple-step">
                            <p>We engage Partner Agents in your area</p>
                        </div>
                        <div class="simple-step">
                            <p>You consider offers presented</p>
                        </div>
                        <div class="simple-step">
                            <p>We manage your sale with our attorneys</p>
                        </div>
                        <div class="simple-step">
                            <p>You Sell</p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="why-we-are-different"></div>
            <br>
        </section>

        <section class="section has-background-light-blue">
            <div class="container">
                <h2 class="title has-text-centered">Why we are different</h2>
                <table id="sell-with-us-table">
                    <thead class="has-text-centered">
                        <tr>
                            <th>Services</th>
                            <th>Traditional Agency</th>
                            <th>NestEgg</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>We work only for YOU the seller, we do not work for buyers</td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/cross.svg"/></td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/></td>
                        </tr>
                        <tr>
                            <td>Collaborating with the Top Agents in your area</td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/cross.svg"/></td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/></td>
                        </tr>
                        <tr>
                            <td>Managing the relationship with Partner Agents on your behalf</td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/cross.svg"/></td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/></td>
                        </tr>
                        <tr>
                            <td>Regular progress updates, keeping you informed every step of the way</td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/cross.svg"/></td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/></td>
                        </tr>
                        <tr>
                            <td>Free legal advice with our attorney panel - on any sale and property related matters</td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/cross.svg"/></td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/></td>
                        </tr>
                        <tr>
                            <td>Management of the sale process until transfer</td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/></td>
                            <td><img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/></td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3">
                                <div class="is-inline-flex">
                                    <img class="cross-tick" src="../assets/images/sell_with_us/cross.svg"/>
                                    <span>Not Included</span>
                                </div>
                                <div class="is-inline-flex">
                                    <img class="cross-tick" src="../assets/images/sell_with_us/tick.svg"/>
                                    <span>Included</span>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </section>

        <section class="section has-text-centered">
            <div class="container">
                <h2 class="title">Ready to sell or want to find out more?</h2>
                <p>One of our expert agents will call you back to discuss your needs</p>
                <br>
                <router-link class="button is-primary" to="/contact-me">Contact Me</router-link>
            </div>
        </section>
    </div>
</template>

<script>
    export default {}
</script>

<style lang="scss">
    @import '../assets/sass/colours.scss';

    #sell-with-us-table {
        border-collapse: separate;
        border-spacing: 5px 7px;
        background: none !important;

        thead {
            th {
                text-align: center;
            }
        }

        td {
            border-radius: 5px;
            vertical-align: middle;
            padding-left: 1rem;
            padding-right: 1rem;
        }

        tbody {
            td:not(:first-child) {
                text-align: center !important;
            }

            td:nth-child(1) {
                background-color: #C9E6F3;
                border: 1px solid #C9E6F3 !important;
            }

            td:nth-child(2) {
                background-color: #ABDBF1;
                border: 1px solid #ABDBF1 !important;
            }

            td:nth-child(3) {
                background-color: $primary;
                border: 1px solid $primary !important;
            }
        }

        tfoot {
            background-color: $primary;

            div {
                align-items: center;
            }
        }

        .cross-tick {
            height: 1.1em;
            padding: 0;
        }
    }

    .simple-steps-container {
        display: flex;

        .simple-steps {
            display: flex;
            justify-content: space-between;

            .simple-step {
                display: flex;

                img {
                    width: 110px;
                    margin-top: -25px;
                }
            }

            .timeline {
                position: absolute;
                z-index: -1;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .simple-steps-container {
            flex-flow: row nowrap;

            .simple-steps {
                flex-flow: column nowrap;

                .simple-step {
                    height: 9vmax;
                    margin-bottom: 1em;
                    align-items: center;

                    p {
                        text-align: left;
                    }

                    .circled-number, img {
                        margin-left: auto;
                        margin-right: auto;
                    }
                }

                .timeline {
                    display: none;
                }
            }

        }

        #sell-with-us-table {
            margin-left: -5%;
            margin-right: -5%;

            thead th:not(:first-child), tbody td:not(:first-child) {
                width: 0%;
            }

            .cross-tick {
                margin: 0.25em;
            }

            tfoot {
                div:nth-child(2) {
                    margin-left: 1em;
                }
            }
        }
    }

    @media screen and (min-width: 769px) {
        .simple-steps-container {
            flex-flow: column nowrap;

            .simple-steps {
                .simple-step {
                    flex: 1;

                    .circled-number, img, p {
                        margin-left: auto;
                        margin-right: auto;
                    }

                    p {
                        padding: 1rem;
                    }
                }

                .timeline {
                    background: linear-gradient(0deg, white 45%, $grey-lighter 50%, white 55%);
                    left: 6rem;
                    top: 6.25rem;
                    width: 85%;
                    height: 9px;
                }
            }
        }

        #sell-with-us-table {
            margin-left: auto;
            margin-right: auto;

            thead {
                th:not(:first-child) {
                    width: 11rem;
                }
            }

            .cross-tick {
                margin: 0.75em;
            }

            tfoot {
                div:nth-child(2) {
                    margin-left: 1em;
                }
            }
        }
    }
</style>